export enum AuditEventType {
  Login = 'login',
  LoginFirstTime = 'login_first_time',
  PlanCreated = 'plan_created',
  PlanSaved = 'plan_saved',
  PlanOpened = 'plan_opened',
  PlanDeleted = 'plan_deleted',
  PlanShared = 'plan_shared',
  PlanExported = 'plan_exported',
  PlanLoaded = 'plan_loaded',
  PlanLoadedUsage = 'plan_loaded_usage',
}

export interface AuditEvent {
  type: AuditEventType
  params: string
  user_email: string
  created_at: Date
}
